import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from "@remix-run/react";
import { CloseButton, Container, MobileCloseButton } from './SearchBar.styles';
import { SearchForm } from './SearchForm';
import SvgChevron from '../../../../../play-core/icons/Chevron';
import { Colors } from '../../../../../play-core/styles/Colors';
import { IconWrapper } from '../../../components/IconWrapper/IconWrapper';
import { usePath } from '../../../config/VideoAppContext';
import { useSearchUrlSync } from '../hooks/use-search-url-sync';
import { useSearchDispatch, useSearchState } from '../SearchContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SearchBar = ({
  inputRef
}) => {
  const {
    searchOpen,
    searchPageOpen,
    previousPage
  } = useSearchState();
  const dispatch = useSearchDispatch();
  const {
    homePath
  } = usePath();
  const {
    t
  } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  useSearchUrlSync();
  const closeSearch = () => {
    dispatch({
      type: 'close'
    });
    const currentUrl = location.pathname + location.search;
    if (previousPage && currentUrl !== previousPage) {
      navigate(previousPage);
    } else if (searchPageOpen) {
      navigate(homePath);
    }
  };
  return /*#__PURE__*/_jsxs(Container, {
    "aria-hidden": !searchOpen,
    isOpen: searchOpen,
    children: [/*#__PURE__*/_jsx(MobileCloseButton, {
      "aria-label": t('global.close'),
      onClick: closeSearch,
      children: /*#__PURE__*/_jsx(IconWrapper, {
        icon: /*#__PURE__*/_jsx(SvgChevron, {
          orientation: 'left'
        }),
        color: Colors.GREY_6a6a6a
      })
    }), /*#__PURE__*/_jsx(SearchForm, {
      ref: inputRef
    }), /*#__PURE__*/_jsx(CloseButton, {
      type: "text",
      size: "small",
      text: t('global.close'),
      tabIndex: searchOpen ? 0 : -1,
      onClick: closeSearch
    })]
  });
};